<template><SimpleModuleDashboard :module-id="Modules.RECIBOS_ERP" :profile-id="Profiles.PERSONAL" include-php-custom :actions="dashboardActions" /></template>
<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'
export default {
  components: { SimpleModuleDashboard },
  data: () => ({ Modules, Profiles }),
  computed: {
    dashboardActions() {
      const actions = [{ id: 'receipts', reference: 'receipts', route: 'ReceiptsErpStaffReceipts', tone: 'primary' }]
      return actions
    },
  },
}
</script>
